import { render, staticRenderFns } from "./AdviserDashboardContainer.vue?vue&type=template&id=366a9932"
import script from "./AdviserDashboardContainer.vue?vue&type=script&lang=js"
export * from "./AdviserDashboardContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports